import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ActionInput from '../../../components/common/actioninput/ActionInputField';
import ButtonComponent from '../../../components/common/button/Button';
import './ApprovalCard.css';
import './index.css';
const ReAssignPlanner = ({ selectedName, selectedEmailId, checkBoxCount, formData, data, clear, approvalCardsData, onChangeReassingComments, reAssignComments, handleApproverChange, handleClear, addApprover, onHandleDeleteIcon, className }) => {
    return (
        <div className={className || 'reassignPlanner_cls'} >
            <div className='approval-items-wrapper'>
                <p style={{ marginTop: '8px', fontSize: '14px' }}>No.of Line Items for Approval</p>
                <ActionInput
                    props={{
                        height: "30px", maxWidth: "70px",
                    }}
                    value={checkBoxCount}
                    disabled={true}
                />
            </div>
            <div className='approval-wrapper'>
                <div className='approver-header-reassign'>
                    <p className='approver-label-width' >Reassign to </p>
                    <p className='email-label-width'>Email ID </p>
                    <p></p>
                </div>
                <div className='approver-container'>
                    <div className='approver-value-width'>
                        <Autocomplete
                            key={selectedName}
                            className="custom-autocomplete"
                            freeSolo
                            options={data}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => <TextField {...params}
                                // label="Search"
                                placeholder='Search Planner'
                                InputLabelProps={{ shrink: false }}

                            />}
                            onChange={(event, value) => handleApproverChange(event, value)}
                            style={{ height: 40, maxWidth: 220 }}
                            value={data.find(obj => obj.name === selectedName) || null}
                        />
                    </div>
                    <div className='approver-email-width' >
                        <ActionInput
                            props={{ height: "40px", maxWidth: "220px", }}
                            placeholder='Email'
                            disabled={true}
                            value={selectedEmailId || ""}
                        />
                    </div>
                </div>
            </div>

            <div style={{ marginTop: 35 }}>
                <label style={{ fontSize: '14px' }}>Reassignments Comments</label>
                <div>
                    <TextField multiline minRows={3} placeholder='Kindly check the Lead time and approve.' style={{ width: '100%' }} onChange={onChangeReassingComments} value={reAssignComments} />
                </div>
            </div>
        </div>
    )
}

const ReAssingPlannerFooter = ({ clearAllDetails, onSubmitHandler, disableSubmitButton, submitLabel, clearAllLabel }) => {

    return (
        <div className='footer-btn-wrapper'>
            <ButtonComponent
                maxWidth="170px"
                label={clearAllLabel || "Clear All"}
                type="primary"
                onClick={clearAllDetails}
            />
            <ButtonComponent
                maxWidth="170px"
                label={submitLabel || "Reassign"}
                bgColor="black"
                color="white"
                onClick={onSubmitHandler}
                disabled={disableSubmitButton}
            />
        </div>
    );
};

export { ReAssignPlanner, ReAssingPlannerFooter };
